import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {Dialog} from '../../../../interfaces/dialog/dialog';
import {LoaderService} from '../../../../services/loader/loader.service';
import {DialogService} from '../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {DialogParams} from '../../../../interfaces/dialog/dialog-params';
import {UserService} from '../../../../services/user/user.service';
import {ActivityService} from '../../../../services/crm/activity/activity.service';
import {Partner} from '../../../../models/partner/partner';
import {AuthService} from '../../../../services/auth/auth.service';
import {AffiliateUser} from '../../../../models/partner/affiliate-user';
import {AffiliateUserService} from '../../../../services/partner/affiliate-user.service';
import {ConfirmDirective} from '../../../../directives/confirm/confirm.directive';
import {ApiResponse} from '../../../../api/api-response';
import {InputSwitchComponent} from '../../../layout/input-switch/input-switch.component';

@Component({
  imports: [
    FormsModule,
    ConfirmDirective,
    InputSwitchComponent
],
  templateUrl: './affiliate-users.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './affiliate-users.component.scss'
})
export class AffiliateUsersComponent implements Dialog {

  private partner: Partner | null = null;

  affiliateUsers: AffiliateUser[] = [];
  loaded: boolean = false;
  submitting: boolean = false;

  constructor(
    private authService: AuthService,
    private loader: LoaderService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private activityService: ActivityService,
    private userService: UserService,
    private affiliateUserService: AffiliateUserService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.partner = params.data;

    if (this.partner) {
      this.affiliateUserService.findAll({partnerId: this.partner.id}).subscribe((affiliateUsers: AffiliateUser[]) => {
        this.affiliateUsers = affiliateUsers;

        this.loaded = true;
      });
    }
  }

  add(): void {
    this.affiliateUsers.push(new AffiliateUser());
  }

  delete(index: number): void {
    const affiliateUser: AffiliateUser = this.affiliateUsers[index];

    if (affiliateUser.id) {
      this.submitting = true;

      this.affiliateUserService.delete(affiliateUser.id).subscribe(() => {
        this.affiliateUsers.splice(index, 1);

        this.submitting = false;
      });
    }
  }

  submit(affiliateUser: AffiliateUser): void {
    this.submitting = true;

    if (!this.partner) {
      return;
    }

    const parameters: any = {
      partnerId: this.partner.id,
      email: affiliateUser.email,
      phoneNumber: affiliateUser.phoneNumber,
      enabled: affiliateUser.enabled,
    };

    if (affiliateUser.id) {
      this.affiliateUserService.update(affiliateUser.id, parameters).subscribe(() => {
        this.snackbar.success('Affiliate user ' + affiliateUser.email + ' updated.');
        this.submitting = false;
      });
    } else {
      this.affiliateUserService.create(parameters).subscribe((response: ApiResponse) => {
        affiliateUser.id = response.getData()['id'] ?? null;
        this.snackbar.success('Affiliate user ' + affiliateUser.email + ' created.');
        this.submitting = false;
      });
    }
  }
}
